@if (!loading()) {
  <cdk-accordion>
    @for (
      chapterWithProgress of chapters();
      track chapterWithProgress.chapter.id
    ) {
      <lyceo-accordion-item
        [expanded]="chapterWithProgress.chapter.id === chapterId()"
      >
        <div header [class.no-icon]="!showProgress()">
          @if (
            chapterWithProgress.chapterProgress?.paragraphsCompleted !==
              chapterWithProgress.chapter.totalParagraphs && showProgress()
          ) {
            <lyceo-progress-donut
              [value]="
                (chapterWithProgress.chapterProgress?.paragraphsCompleted ??
                  0) / chapterWithProgress.chapter.totalParagraphs
              "
            />
          }
          @if (
            chapterWithProgress.chapterProgress?.paragraphsCompleted ===
              chapterWithProgress.chapter.totalParagraphs && showProgress()
          ) {
            <fa-icon [icon]="faCircleCheck" />
          }
          <span
            class="label-large"
            [class.paragraph-done]="
              chapterWithProgress.chapterProgress?.paragraphsCompleted ===
                chapterWithProgress.chapter.totalParagraphs && showProgress()
            "
            >{{ chapterWithProgress.chapter.name }}</span
          >
        </div>
        <div content>
          <ul>
            @for (
              paragraphWithProgress of chapterWithProgress.paragraphs;
              track paragraphWithProgress.paragraph.id
            ) {
              <li
                [class.selected]="
                  paragraphId() === paragraphWithProgress.paragraph.id
                "
                [class.label-large]="
                  paragraphId() === paragraphWithProgress.paragraph.id
                "
                [class.completed]="
                  paragraphWithProgress.paragraphProgress?.completed
                "
                [class.label-medium]="
                  paragraphWithProgress.paragraphProgress?.completed
                "
                (click)="paragraphClicked(paragraphWithProgress.paragraph)"
              >
                <div class="icon">
                  <fa-icon
                    [class.selected]="
                      paragraphId() === paragraphWithProgress.paragraph.id
                    "
                    [icon]="
                      paragraphId() === paragraphWithProgress.paragraph.id
                        ? faCirclePlay
                        : paragraphWithProgress.paragraphProgress?.completed &&
                            showProgress()
                          ? faCircleCheck
                          : faCirclePlayRegular
                    "
                  />
                </div>
                {{ paragraphWithProgress.paragraph.name }}
              </li>
            }
          </ul>
        </div>
      </lyceo-accordion-item>
    }
    @if (finalExam()) {
      <lyceo-accordion-item
        [showChevron]="false"
        (click)="finalExamClicked.emit()"
      >
        <div header>
          <fa-icon [icon]="faMedal" />
          <span class="label-large">Eindtoets</span>
        </div>
      </lyceo-accordion-item>
    }
  </cdk-accordion>
} @else {
  @for (item of ['l', 'o', 'a', 'd']; track item) {
    <lyceo-accordion-item [disabled]="true">
      <div header>
        <div class="icon">
          <lyceo-progress-donut [value]="0 / 0" />
        </div>
        <lyceo-skeleton-text />
      </div>
    </lyceo-accordion-item>
  }
}
